export default __webpack_public_path__ + "static/media/dx.8113f2b9.png";